export default __webpack_public_path__ + "assets/png/8ffae6ef569a1f66a3bc3e6c24291b31.png";